import { consumeGas } from "../Frame/consumeGas.js";
import { pushStack } from "../Frame/pushStack.js";

/**
 * CALLDATASIZE opcode (0x36) - Get size of input data in current environment
 *
 * Stack: [] => [size]
 * Gas: 2 (GasQuickStep)
 *
 * @param {import("../Frame/FrameType.js").BrandedFrame} frame - Frame instance
 * @returns {import("../Frame/FrameType.js").EvmError | null} Error if any
 */
export function calldatasize(frame) {
	const gasErr = consumeGas(frame, 2n);
	if (gasErr) return gasErr;

	const pushErr = pushStack(frame, BigInt(frame.calldata.length));
	if (pushErr) return pushErr;

	frame.pc += 1;
	return null;
}
